const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'is_alive', label: 'Status', sortable: false },
    { key: 'fqdn', label: 'Domain', sortable: false },
    { key: 'name', label: 'Name', sortable: false },
    { key: 'last_visit', label: 'Last Visit', sortable: true },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'is_alive', label: '상태', sortable: false },
    { key: 'fqdn', label: 'Domain', sortable: false },
    { key: 'name', label: '이름', sortable: false },
    { key: 'last_visit', label: '마지막 방문', sortable: true },
    // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
  ],
  JP : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'is_alive', label: 'ステータス', sortable: false },
    { key: 'fqdn', label: 'ドメイン', sortable: false },
    { key: 'name', label: '名前', sortable: false },
    { key: 'last_visit', label: '最終訪問日', sortable: true },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ]
}

const _i18n_warning = {
  policy_check : {
    EN: `Please register at least one policy`,
    KO: `Please register at least one policy`,
    JP: `少なくとも 1 つのポリシーを登録してください`
  }
}

const _i18n_error = {
  status_change : {
    EN: `Failed to change settings.`,
    KO: `Failed to change settings.`,
    JP: `設定の変更に失敗しました`
  }
}

const _i18n_data = {
  i18n_fields,
  _i18n_warning,
  _i18n_error
}

export default _i18n_data